"use client"

import {useUiControlLabels} from "@/components/i18n/ui-control-labels-context"
import { useId } from "react"
import { useField, useFormikContext } from "formik"

import { Label } from "@/components/ui/label"
import { TimezoneSelect } from "@/components/ui/timezone-select"

/** Connects the shared searchable IANA time zone picker to a Formik form. */
export function FormTimezoneSelect({ name, label }: { name: string; label: string }) {
  const inputId = useId()
  const {fieldError} = useUiControlLabels()
  const [field, meta] = useField<string>(name)
  const { setFieldTouched, setFieldValue } = useFormikContext()
  const error = meta.touched && meta.error ? meta.error : null

  return (
    <div className="min-w-0 space-y-1.5">
      <Label htmlFor={inputId}>{label}</Label>
      <TimezoneSelect
        id={inputId}
        describedBy={error ? `${inputId}-error` : undefined}
        value={field.value}
        onChange={value => {
          void setFieldValue(name, value)
          void setFieldTouched(name, true, false)
        }}
        className="h-10"
      />
      {error ? <p key={fieldError(error)} id={`${inputId}-error`} className="text-xs font-medium text-destructive">{fieldError(error)}</p> : null}
    </div>
  )
}
